/** Frames a filter row's controls like a filter group. */
export const FILTER_ROW_FRAME_CLASSES = '-mx-1.5 rounded border border-primary bg-primary p-1.5'
